import Vue from 'vue'
import productEdit from '@/components/pages/product-edit/product-edit.vue'
import store from '@/store/price-settings'

window.productEditPageEventBus = new Vue();

const collection = document.getElementsByClassName('vue-js-product-price-setting');

const element = collection.length > 0 ? [...collection][0] as HTMLElement : null;
let productId: number | null = null;

if(element?.dataset?.productid) {
  productId = parseInt(element.dataset.productid)
}

if(productId && !isNaN(productId)) {
  new Vue({
    store,
    data() {
      return {
        productId: productId
      }
    },
    render: h => h(productEdit)
  }).$mount('.vue-js-product-price-setting')
}
else {
  console.warn('productId not set or NaN');
}